const alignRight = () => ({
  style: {
    textAlign: 'right',
  },
})

const alignCenter = () => ({
  style: {
    textAlign: 'center',
  },
})

const stringToDate = (dateString: string): Date => {
  const [datePart, timePart] = dateString.split(' ')
  const [day, month, year] = datePart.split('/').map(Number)
  if (timePart) {
    const [hours, minutes, seconds] = timePart.split(':').map(Number)
    return new Date(year, month - 1, day, hours, minutes, seconds)
  }
  return new Date(year, month - 1, day)
}

export default [
  {
    Header: 'FC',
    id: 'fc',
    accessor: 'fc',
    width: 130,
  },
  {
    Header: 'Código do Pedido',
    id: 'codigo',
    accessor: 'orderCode',
    width: 150,
    getProps: alignRight,
  },
  {
    Header: 'Quantidade',
    id: 'quantidade',
    accessor: 'quantity',
    width: 100,
    getProps: alignRight,
    sortMethod: (a: any, b: any) => {
      const numberA = Number(a)
      const numberB = Number(b)

      if (numberA < numberB) {
        return -1
      }
      if (numberA > numberB) {
        return 1
      }

      return 0
    },
  },
  {
    Header: 'Data de Entrega',
    id: 'deliveryDate',
    accessor: 'deliveryDate',
    width: 150,
    getProps: alignCenter,
    sortMethod: (a: any, b: any) => {
      const dateA = stringToDate(a)
      const dateB = stringToDate(b)

      if (dateA < dateB) {
        return -1
      }
      if (dateA > dateB) {
        return 1
      }

      return 0
    },
  },
  {
    Header: 'Data da Reserva',
    id: 'reserveDate',
    accessor: 'reserveDate',
    width: 150,
    getProps: alignCenter,
    sortMethod: (a: any, b: any) => {
      const dateA = stringToDate(a)
      const dateB = stringToDate(b)

      if (dateA < dateB) {
        return -1
      }
      if (dateA > dateB) {
        return 1
      }

      return 0
    },
  },
  {
    Header: 'Sistema',
    id: 'sourceSystem',
    accessor: 'sourceSystem',
    width: 150,
    getProps: alignRight,
  },
  {
    Header: '',
    id: 'dumb',
    accessor: 'dumb',
    width: 1,
  },
]
